import { render, staticRenderFns } from "./AudioCard.vue?vue&type=template&id=65a05686&scoped=true&"
import script from "./AudioCard.vue?vue&type=script&lang=js&"
export * from "./AudioCard.vue?vue&type=script&lang=js&"
import style0 from "./AudioCard.vue?vue&type=style&index=0&id=65a05686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a05686",
  null
  
)

export default component.exports